import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class EaHouseFormBuilder extends PrFormAbstract {
  mainAddress;

  generate(entity: any) {
    let options: AbstractControlOptions = {};

    this.mainAddress = entity.addresses.find(address => address.isMain) || {};
    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        address: this.formBuilder.group({
          street: [
            this.mainAddress ? this.mainAddress.street : null,
            Validators.nullValidator,
          ],
          zipCode: [
            this.mainAddress ? this.mainAddress.zipCode : null,
            Validators.nullValidator,
          ],
          city: [
            this.mainAddress ? this.mainAddress.city : null,
            Validators.nullValidator,
          ],
          country: [
            this.mainAddress ? this.mainAddress.country : null,
            Validators.nullValidator,
          ],
        }),
        matrimonialRegime: this.formBuilder.group({
          maritalSituation: [
            entity ? entity.maritalSituation : null,
            [Validators.required],
          ],
          regime: [entity && entity.regimeData ? entity.regimeData.type : null],
          location: [
            entity && entity.regimeData ? entity.regimeData.location : null,
          ],
          raiseChild5: [entity ? entity.taxData.raiseChild5 : false],
        }),
        fiscality: this.formBuilder.group({
          taxShare: [entity ? entity.taxData.taxShare : null],
        }),
        situation: this.formBuilder.group({
          situation: [
            this.mainAddress ? this.mainAddress.situation : null,
            Validators.nullValidator,
          ],
        }),
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      maritalSituation: this.emptyIsNull(
        this.form.value.matrimonialRegime.maritalSituation,
      ),
      address: {
        street: this.form.value.address.street,
        zipCode: this.form.value.address.zipCode,
        city: this.form.value.address.city,
        country: this.form.value.address.country?.value
          ? this.form.value.address.country.value
          : this.form.value.address.country || '',
        situation: this.form.value.situation.situation,
      },

      taxData: {
        raiseChild5: this.emptyIsNull(
          this.form.value.matrimonialRegime.raiseChild5,
        ),
        taxShare: this.emptyIsNull(this.form.value.fiscality.taxShare),
      },
      regimeData: ['MARRIED', 'CIVILPARTNER'].includes(
        this.form.get('matrimonialRegime.maritalSituation').value,
      )
        ? {
            id: this.entity.regimeData
              ? this.emptyIsNull(this.entity.regimeData.id)
              : undefined,
            type: this.emptyIsNull(this.form.value.matrimonialRegime.regime),
            location: this.emptyIsNull(
              this.form.value.matrimonialRegime.location,
            ),
            isCurrent: true,
          }
        : undefined,
    };
    return dto;
  }
}
